import { observer } from 'mobx-react';

import popupBoxStore from './PopupBoxStore';

import './PopupBox.scss';

export const PopupBox = observer(() => {
  return (
    <div className={`popupbox ${popupBoxStore.isOpen ? 'popupbox_opened' : ''}`}>
      {popupBoxStore.message && <div className='popupbox__message'>{popupBoxStore.message}</div>}
    </div>
  );
});
